// ** Root Slice & Helper Functions
import { baseApi } from './baseApi'
import { customErrorHandler } from './customErrorHandler'

/**
 * Xero / QuickBooks consent URLs.
 *
 * RTK Query endpoint names are global. These endpoints used to be declared in
 * both the create-company and edit-company integration slices; whichever
 * module happened to load last silently overrode the other. The create-company
 * copy dropped the `form` param, which made the OAuth callback redirect to the
 * edit-company screen even when the flow started in create-client. Keep a
 * single definition here so that cannot happen again.
 */
const integrationConsentApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		xeroUrl: build.query<string, { companyId: number; form?: string }>({
			query: ({ companyId, form }) => {
				const params = new URLSearchParams({
					companyId: String(companyId)
				})

				if (form) params.set('form', form)

				return {
					url: `/integrations/xero/consent-url?${params.toString()}`,
					responseHandler: async (response) => await response.text()
				}
			},
			transformErrorResponse: customErrorHandler
		}),
		quickbooksUrl: build.query<string, { companyId: number; form?: string }>({
			query: ({ companyId, form }) => {
				const params = new URLSearchParams({
					companyId: String(companyId)
				})

				if (form) params.set('form', form)

				return {
					url: `/integrations/quickbooks/consent-url?${params.toString()}`,
					responseHandler: async (response) => await response.text()
				}
			},
			transformErrorResponse: customErrorHandler
		})
	})
})

export const { useXeroUrlQuery, useQuickbooksUrlQuery } = integrationConsentApi
